import React from "react";
import { Route, Navigate, Routes as RouterRoutes, useLocation } from "react-router-dom";
import AdminLayout from '../components/adminLayout';
import SiteLayout from '../components/siteLayout';
import { startsWith } from 'lodash';

import HomePage from "../pages/homePage";
import WeddingsPage from "../pages/weddingsPage";
import EventsPage from "../pages/eventsPage";
import SocialPage from "../pages/socialPage";
import ChurchPage from "../pages/churchPage";
import CorporatePage from "../pages/corporatePage";
import EnhancementsPage from "../pages/enhancementsPage";
import MyBioPage from "../pages/myBioPage";
import MyProcessPage from "../pages/myProcessPage";
import EquipmentPage from "../pages/equipmentPage";
import WhyMePage from "../pages/whyMePage";
import FAQPage from "../pages/faqPage";
import ContactPage from "../pages/contactPage";
import ContractPage from "../pages/contractPage";
import LoginPage from "../pages/loginPage";

const Routes = () => {
  const location = useLocation();

  const renderAdminLayout = () => {
    return (
      <AdminLayout>
        {renderRoutes()}
      </AdminLayout>
    )
  }

  const renderSiteLayout = () => {
    return (
      <SiteLayout>
        { renderRoutes() }
      </SiteLayout>
    )
  }

  const renderRoutes = () => {
    return (
      <RouterRoutes>
        <Route path="/" element={<HomePage />} />
        <Route path="/weddings" element={<WeddingsPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/social" element={<SocialPage />} />
        <Route path="/events/church" element={<ChurchPage />} />
        <Route path="/events/corporate" element={<CorporatePage />} />
        <Route path="/enhancements" element={<EnhancementsPage />} />
        <Route path="/about/bio" element={<MyBioPage />} />
        <Route path="/about/process" element={<MyProcessPage />} />
        <Route path="/about/equipment" element={<EquipmentPage />} />
        <Route path="/about/why" element={<WhyMePage />} />
        <Route path="/about/faqs" element={<FAQPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/contract" element={<ContractPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/" state={{ from: location }} replace />} />
      </RouterRoutes>
    )
  }

  const renderLayout = () => {
    if (startsWith(location.pathname, '/admin/login')) {
      return renderRoutes();
    } else if (startsWith(location.pathname, '/admin')) {
      return renderAdminLayout();
    } else {
      return renderSiteLayout();
    }
  }

  return renderLayout();
}

export default Routes;
